// AlertPanel
import ClassNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import Message from './Message.jsx';
import { getTranslator } from '../locales';
import { toggleNotificationPanel } from '../redux/actions/insidersAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    labels: {
      NOTIFICATION: t.t('NOTIFICATION'),
      OK_CLOSE_NOTIFICATION: t.t('Close notification'),
    },
    notifications: Store.insiders.notifications
  };
})

export default class AlertPanel extends React.Component {
  handleClose() {
    this.props.dispatch(toggleNotificationPanel());
  }

  render() {
    const { alert } = this.props.notifications;

    return (
      <div className={ClassNames(this.props.notifications.itemClass)}>
        <div className='heading brandedColor_bg'>
          <h2><i className='pe-7s-bell'></i> {this.props.labels.NOTIFICATION}</h2>
        </div>
        <div className='inner-content'>
          {
            (() => {
              if (alert.message) {
                let {author} = alert;
                author.insider = true;

                return <Message
                  key='alert-panel-msg'
                  message={{
                    'author': author,
                    'body': alert.message,
                    'createdAt': alert.createdAt
                  }}
                  isOwn={false}
                  typing={false}
                />
              }
            })()
          }
        </div>
        <div className='actions'>
          <button className='btn btn-secondary'
            value='{this.props.labels.OK_CLOSE_NOTIFICATION}'
            onClick={this.handleClose.bind(this)}>
              {this.props.labels.OK_CLOSE_NOTIFICATION}
          </button>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/AlertPanel.jsx